import React from 'react';

import { BridgeSiteSettingsProps } from '~src/settings/general-settings/components/bridge-settings/BridgeSiteSettings';
import { FeatureFlags } from '~src/ts/FeatureFlags';

import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { multiPoolTableStyle, sectionExtraPaddingBottom } from './BridgeMultiPoolSection/BridgeMultiPoolSection';
import { BridgeRemoteAgentsSectionBody } from './BridgeRemoteAgentsSection/BridgeRemoteAgentsSectionBody';
import { BridgeRemoteAgentsSectionHeaders } from './BridgeRemoteAgentsSection/BridgeRemoteAgentsSectionHeaders';

export function BridgeUnassignedRemoteAgentsSection(props: BridgeSiteSettingsProps) {
  return <>
    {FeatureFlags.edgeMultiPoolEnabled ?
      <SettingsSection title={''} testId={'bridge-unassigned-remote-agents-section'}>
        <div className={sectionExtraPaddingBottom}>
          <div className={'tb-data-grid-title-text'}>{Messages.siteRemoteAgentSettingsUnassignedClients()}</div>
          <table className={`${multiPoolTableStyle} tb-static-grid-table-remote-agents-width`}>
            <BridgeRemoteAgentsSectionHeaders isDefaultPool={false} />
            <BridgeRemoteAgentsSectionBody
              isDefaultPool={false}
              pools={props.edgePools.userDefinedPools}
              connectionStatuses={props.connectionStatuses}
              siteId={props.settings.id}
              refreshEdgePools={props.refreshEdgePools}
              agents={Object.values(props.edgePools.unassignedAgents)}
              hasLoadedEdgePools={props.hasLoadedEdgePools}
            />
          </table>
        </div>
      </SettingsSection>
      : null}
  </>;
}

/* for registering the component in settings registry */
export const BridgeUnassignedRemoteAgentsSectionSpecs = componentRegistryEntry({
  name: 'BridgeUnassignedRemoteAgentsSection',
  component: BridgeUnassignedRemoteAgentsSection
});
